/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Performancetable_Collections_Topfreetoplay4Inputs */

const id_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free-to-Play Teratas`)
};

const ms_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percuma Dimain Teratas`)
};

const da_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Free-to-Play`)
};

const de_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Kostenlos Spielbar`)
};

const en_us2_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Free-to-Play`)
};

const es_es2_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free-to-play destacados`)
};

const es_mx2_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejores juegos gratis`)
};

const fil_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Nangungunang Free-to-Play`)
};

const fr_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilleurs free-to-play`)
};

const it_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Migliori free-to-play`)
};

const hu_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legjobb ingyenesen játszhatók`)
};

const nl_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top free-to-play`)
};

const no_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topp gratis-å-spille`)
};

const pl_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najlepsze darmowe`)
};

const pt_br2_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principais gratuitos`)
};

const pt_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melhores free-to-play`)
};

const ro_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Free-to-Play`)
};

const fi_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parhaat ilmaispelit`)
};

const sv_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topp gratis-att-spela`)
};

const vi_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chơi miễn phí hàng đầu`)
};

const tr_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En İyi Ücretsiz Oynanabilir`)
};

const cs_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejlepší hry zdarma`)
};

const bg_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Топ безплатни за игра`)
};

const ru_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лучшие бесплатные`)
};

const uk_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найкращі Free-to-Play`)
};

const ar_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أفضل الألعاب المجانية`)
};

const hi_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टॉप मुफ़्त-खेलें`)
};

const th_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เล่นฟรียอดนิยม`)
};

const ja_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トップ無料プレイ`)
};

const zh_cn2_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`热门免费游戏`)
};

const zh_hant1_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`熱門免費遊玩`)
};

const ko_components_performancetable_collections_topfreetoplay4 = /** @type {(inputs: Components_Performancetable_Collections_Topfreetoplay4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료 플레이 상위`)
};

/**
* | output |
* | --- |
* | "Top Free-to-Play" |
*
* @param {Components_Performancetable_Collections_Topfreetoplay4Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_collections_topfreetoplay4 = /** @type {((inputs?: Components_Performancetable_Collections_Topfreetoplay4Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Collections_Topfreetoplay4Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "ms") return ms_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "da") return da_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "de") return de_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "fil") return fil_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "fr") return fr_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "it") return it_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "hu") return hu_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "nl") return nl_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "no") return no_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "pl") return pl_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "pt") return pt_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "ro") return ro_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "fi") return fi_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "sv") return sv_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "vi") return vi_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "tr") return tr_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "cs") return cs_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "bg") return bg_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "ru") return ru_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "uk") return uk_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "ar") return ar_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "hi") return hi_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "th") return th_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "ja") return ja_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_collections_topfreetoplay4(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_collections_topfreetoplay4(inputs)
	return ko_components_performancetable_collections_topfreetoplay4(inputs)
});
export { components_performancetable_collections_topfreetoplay4 as "components.performanceTable.collections.topFreeToPlay" }